<app-base-generic-questionnaire
  [title]="'TGA.Questionnaire.PlantingQuestions.label' | translate"
  [questions]="plantingQuestions"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropYear]="cropYear"
></app-base-generic-questionnaire>
